<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">

      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="3"></ucMenu>

          <div class="right_con">
            <div class="goods_main">
              <p class="fb">工单反馈</p>
              <div class="select_wrap">
                <el-select class="w290" v-model="searchData.status" placeholder="请选择" clearable filterable >
                  <p slot="prefix" class="label_title">工单状态</p>
                  <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <el-input class="w290" v-model="searchData.id" placeholder="请输入关键词" clearable>
                  <p slot="prefix" class="label_title">工单编号</p>
                </el-input>
                <el-input class="w290" v-model="searchData.title" placeholder="请输入关键词" clearable>
                  <p slot="prefix" class="label_title">工单标题</p>
                </el-input>

                <el-button plain size="small" @click="doSearch()">查询</el-button>
                <el-button plain size="small" @click="resetSearch()">重置</el-button>
                <el-button plain size="small" type="primary" @click="showCreateDialog()">创建</el-button>
              </div>

              <div class="table_wrap mt-4">
                <el-table :data="list" style="width: 100%">
                  <el-table-column prop="id" label="编号" width="100" align="center"></el-table-column>
                  <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.status === 1" size="mini" type="warning">待处理</el-tag>
                      <el-tag v-if="scope.row.status === 2" size="mini" type="primary">待反馈</el-tag>
                      <el-tag v-if="scope.row.status === 3" size="mini" type="success">已完结</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="title" label="标题"></el-table-column>
                  <el-table-column prop="op" label="操作" width="200" fixed="right" align="center">
                    <template slot-scope="scope">
                      <div class="flex items-center justify-center gap-x-2">
                        <el-link type="primary" size="small" @click="showDetailDialog(scope.row)">详情</el-link>
                        <el-link size="small" type="success" @click="handlerFinish(scope.row, $event)">结单</el-link>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div class="turn_page mt-3">
                <el-pagination
                    layout="total,prev, pager, next, jumper"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="page_data.total"
                    :page-size="page_data.limit"
                    :current-page="page_data.current"
                    @current-change="currentChange"
                >
                </el-pagination>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <myFoot></myFoot>

    <create-dialog :visible="dialog.create" @close="dialog.create = false;getList(true);"></create-dialog>
    <detail-dialog :visible="dialog.detail" :info="detailInfo" @close="dialog.detail = false;getList(true);"></detail-dialog>
  </div>
</template>

<script>
import {defineComponent} from "vue";
import {mapActions} from "vuex";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import DetailDialog from "./components/index/detail.vue"
import CreateDialog from "./components/index/create.vue"

export default defineComponent({
  components: {ucMenu, myFoot, myHead,DetailDialog,CreateDialog},
  data(){
    return {
      searchData:{},
      list: [],
      statusList: [],
      detailInfo:{id: 0},
      page_data: {
        limit: 10,
        current: 1,
        total: 0,
      },
      dialog:{
        create: false,
        detail: false,
      },
    }
  },
  async mounted() {
    this.getList(true)
  },
  methods:{
    ...mapActions({
      getWorkOrderList: "ucenter/getWorkOrderList",
      getWorkOrderDetail: "ucenter/getWorkOrderDetail",
      opCreateWorkOrder: "ucenter/opCreateWorkOrder",
      opReplyWorkOrder: "ucenter/opReplyWorkOrder",
      opFinishWorkOrder: "ucenter/opFinishWorkOrder",
    }),
    resetSearch() {
      this.searchData = {}
      this.checkAll = false
      this.checkList = []
      this.getList()
    },
    doSearch() {
      this.page_data.page = 1
      this.checkAll = false
      this.checkList = []
      this.getList()
    },
    getList(reset = false) {
      if (reset) {
        this.page_data.current = 1;
      }
      this.getWorkOrderList({
        data: {
          ...this.searchData,
          page: this.page_data.current,
          limit: this.page_data.limit,
        },
        success: (res) => {
          if(res.data.current_page == 1){
            this.statusList = res.data.filter_data.status
          }

          this.list = res.data.data.map(item => {
            return Object.assign(item, {})
          });
          this.page_data.current = res.data.current_page;
          this.page_data.total = res.data.total;
        }
      })
    },
    showCreateDialog(){
      this.dialog.create = true;
    },
    showDetailDialog(row){
      this.getWorkOrderDetail({
        data:{id: row.id},
        success: res=>{
          if(res.code===200) {
            this.detailInfo = res.data
            this.dialog.detail = true;
          }else{
            this.$message({message: res.msg,type: 'error',});
          }
        }
      })
    },
    handlerFinish(row){
      this.$confirm('确认关闭？')
          .then(res => {
            if(res === 'confirm'){
              this.opFinishWorkOrder({
                data:{
                  id: row.id
                },
                success: (res) => {
                  if(res.code===200){
                    this.$message({message: res.msg,type: 'success',});
                  } else {
                    this.$message({message: res.msg,type: 'error',});
                  }
                }
              })
            }
          })
          .catch(err => {
            console.log(err);
          });
    },
    currentChange(val){
      this.page_data.current = val
      this.getList()
    }
  }
})
</script>

<style lang="less" scoped>
.wrap .wrap_body {
  display: flex;
  flex-direction: column;
}

.center {
  display: flex;
  flex: 1;
}

.ucenter_main {
  padding: 30px 0 40px;
  display: flex;
  justify-content: space-between;
  flex: 1;
}

.right_con {
  width: 980px;
  background: #fff;
}


.right_con {
  width: 980px;
  background: #fff;
}

.goods_main {
  padding: 36px 40px 46px;
  min-height: 70vh;
}

.select_wrap {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
}

.select_wrap .mr {
  margin-right: 15px;
}

.select_wrap .w290 {
  width: 290px;
  margin-top: 14px;
  margin-right: 15px;
}

.select_wrap .w290:nth-child(3n) {
  margin-right: 0;
}

.select_wrap .label_title {
  width: 96px;
  height: 100%;
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  padding-left: 6px;
}

.select_wrap .label_title .icon-shuoming {
  font-size: 12px;
  color: #999;
  margin-left: 2px;
}

.tabs_wrap {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}

.tabs_wrap .tab {
  height: 100%;
  padding: 30px 16px 0;
  position: relative;
  line-height: 1;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs_wrap .tab .mark {
  position: absolute;
  vertical-align: middle;
  display: inline-block;
  right: -10px;
  bottom: 10px;
}

.tabs_wrap .tab.active {
  font-weight: bold;
  color: var(--red);
}

.tabs_wrap .tab.active::after {
  content: '';
  width: 100%;
  height: 3px;
  background: var(--red);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
}

.tabs_wrap .tab .iconfont {
  font-size: 14px;
  color: #1966ff;
  margin-left: 4px;
}

.totals_btn {
  margin-top: 14px;
  display: flex;
  align-items: center;
}

.totals_btn .totals {
  font-size: 12px;
  color: #333;
  padding-right: 16px;
  margin-right: 16px;
  line-height: 1;
  border-right: 1px solid #ccc;
}

.total_profit {
  margin-left: 10px;
  font-size: 14px;
}

.totals_btn .decrypt_msg {
  font-size: 14px;
  color: var(--red);
  padding-left: 10px;
}

.list_title {
  width: 100%;
  height: 50px;
  background: #f9f9f9;
  margin-top: 10px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;
  line-height: 1;
}

.list_title .checkall {
  margin-left: 20px;
}

.list_title .t1 {
  margin-left: 10px;
  width: 182px;
}

.list_title .t2 {
  margin: 0 20px;
  width: 60px;
  text-align: right;
}

.list_title .t3 {
  margin: 0 10px;
  width: 140px;
  text-align: left;
}

.list_title .t4 {
  margin-left: 20px;
  width: 100px;
  text-align: right;
}

.list_title .t5 {
  margin: 0 20px;
  width: 130px;
  text-align: left;
}

.list_title .t6 {
  margin: 0 20px 0 0;
  flex: 1;
  text-align: left;
}

.list_title .t7 {
  margin: 0 20px 0 0;
  flex: 1;
  text-align: right;
}

.list_title .t8 {
  margin: 0 20px 0 0;
  flex: 1;
  text-align: right;
}


</style>
<style>
.has-time .el-button {
  padding: 7px 15px;
}

.select_wrap .el-button {
  margin-top: 14px;
}

.select_wrap .el-range-editor .el-range-input {
  font-size: 1em;
}

.select_wrap .el-input--prefix .el-input__inner {
  padding-left: 96px !important;
  height: 34px !important;
  line-height: 34px !important;
  font-size: 12px !important;
}

.el-select .el-input.is-focus .el-input__inner, .el-select .el-input__inner:focus {
  border-color: var(--red);
}

.el-select-dropdown__item.selected {
  color: var(--red);
}

.select_wrap .el-input--prefix .el-input__inner:focus {
  border-color: var(--red);
}

.el-date-editor .el-range-separator {
  line-height: 26px;
}

.el-date-editor {
  width: 290px !important;
  height: 34px !important;
  line-height: 34px !important;
  font-size: 12px !important;
  margin-top: 14px;
}

.el-range-editor.is-active, .el-range-editor.is-active:hover {
  border-color: var(--red);
}

.el-date-table td.end-date span, .el-date-table td.start-date span {
  background-color: var(--red);
}

.el-date-table td.today span {
  color: var(--red);
}

.el-picker-panel__icon-btn:hover, .el-date-table td span:hover, .el-date-table td div:hover, .el-date-table td.available:hover, .el-picker-panel__shortcut:hover {
  color: var(--red);
}

.el-button {
  color: #333;
  border-color: #ddd;
}

.el-button--small {
  padding: 7px 15px;
}

.el-checkbox {
  color: #666;
  display: flex;
  align-items: center;
}

.el-checkbox__inner {
  border-color: #ddd;
  width: 16px;
  height: 16px;
}

.el-checkbox__input {
  display: flex;
}

.el-checkbox__label {
  font-size: 12px;
  line-height: 1;
}

.el-checkbox__inner::after {
  height: 9px;
  left: 5px;
}

.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  height: 4px;
}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus {
  border-color: var(--red);
}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked + .el-checkbox__label, .el-pager li.active, .el-pagination button:hover, .el-pager li:hover {
  color: var(--red);
}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--red);
}

.el-input__icon {
  line-height: unset;
}

.el-button--primary, .el-button--primary:hover {
  background-color: var(--red) !important;
  border-color: var(--red) !important;
  color: #fff !important;
}

.el-button:hover {
  border-color: var(--red) !important;
  background-color: rgba(240, 65, 62, 0.1) !important;
  color: var(--red) !important;
}

.el-date-editor--datetimerange .el-icon-time {
  line-height: 28px;
}

.el-date-editor .el-range-separator {
  width: 20px;
}
.red{
  color: var(--red) !important;
}
</style>